import { createFileRoute } from "@tanstack/react-router";

import { MedicalUnifiedClient } from "@/components/admin/medical/medical-unified-client";

/**
 * Admin → Medical entity graph (Track E).
 *
 * 5-tab dashboard for the medical SEO graph: Procedures, Diseases, Topics,
 * Comparisons, Public Health. Mirrors the specialties dashboard pattern —
 * URL-driven tab state via `?tab=`, identical create/edit/AI-generate/translate/
 * publish flow. Calls Track C admin endpoints which may not be merged yet;
 * fetchers degrade gracefully (empty state + helpful notice).
 */

type MedicalTab = "procedures" | "diseases" | "topics" | "comparisons" | "public-health";

interface MedicalSearch {
  tab?: MedicalTab;
}

const VALID_TABS: MedicalTab[] = [
  "procedures",
  "diseases",
  "topics",
  "comparisons",
  "public-health",
];

function normalizeTabParam(raw: unknown): MedicalSearch["tab"] {
  if (typeof raw !== "string") return undefined;
  return VALID_TABS.includes(raw as MedicalTab) ? (raw as MedicalTab) : undefined;
}

export const Route = createFileRoute("/_authenticated/medical")({
  component: MedicalUnifiedClient,
  validateSearch: (search: Record<string, unknown>): MedicalSearch => ({
    tab: normalizeTabParam(search.tab),
  }),
});
